import { FooterProp } from "@/models/FooterProp";

export const footerProps: FooterProp = {
  showFirstLastPage: true,
  firstIcon: "mdi-arrow-collapse-left",
  lastIcon: "mdi-arrow-collapse-right",
  prevIcon: "mdi-arrow-left",
  nextIcon: "mdi-arrow-right"
};
